/**
 * Centralized Tenant Configuration
 * Maps URL hostnames to corporation names for dynamic branding.
 * Used across all user-facing pages: headers, LOI letters, declarations, etc.
 */

const TENANT_MAP = {
  "msobcfdc": {
    tenantId: "msobcfdc",
    url: "msobcfdc.in",
    nameMarathi: "महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित",
    nameEnglish: "MAHARASHTRA STATE OBC FINANCE & DEVELOPMENT CORPORATION LTD",
    subCompanyMarathi: "",
    subCompanyEnglish: "",
    cin: "U74999MH1999SGC119586",
    isParent: true,
    type: "Universal",
    castes: [],
  },
  "spkemavm": {
    tenantId: "spkemavm",
    url: "spkemavm.msobcfdc.in",
    nameMarathi: "शामराव पेजे कोकण इतर मागासवर्ग आर्थिक विकास महामंडळ",
    nameEnglish: "Shamrao Peje Konkan OBC Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Universal",
    castes: [],
  },
  "skgyavm": {
    tenantId: "skgyavm",
    url: "skgyavm.msobcfdc.in",
    nameMarathi: "संत काशिबा गुरव युवा आर्थिक विकास महामंडळ",
    nameEnglish: "Sant Kashiba Gurav Youth Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U64920MH2023SGC414854",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 43, casteName: "गुरव" },
    ],
  },
  "jmbavm": {
    tenantId: "jmbavm",
    url: "jmbavm.msobcfdc.in",
    nameMarathi: "जगद्ज्योती महात्मा बसवेश्वर आर्थिक विकास महामंडळ",
    nameEnglish: "Jagadjyoti Mahatma Basaveshwar Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 43,  casteName: "लिंगायत गुरव" },
      { casteCode: 58,  casteName: "जंगम, मालाजंगम (विरभद्र) लिंगायत जंगम" },
      { casteCode: 82,  casteName: "लिंगायत कुंभार" },
      { casteCode: 108, casteName: "लिंगायत न्हावी" },
      { casteCode: 125, casteName: "लिंगायत परीट, लिंगायत धोबी" },
      { casteCode: 127, casteName: "लिंगायत फुलारी" },
      { casteCode: 174, casteName: "लिंगायत सुतार" },
      { casteCode: 181, casteName: "लिंगायत तेली" },
      { casteCode: 182, casteName: "लिंगायत माळी" },
      { casteCode: 190, casteName: "लिंगायत वाणी व लिंगायत तांबोळी" },
      { casteCode: 338, casteName: "लिंगायत कुल्लेकडगी" },
    ],
  },
  "ssmkm": {
    tenantId: "ssmkm",
    url: "ssmkm.msobcfdc.in",
    nameMarathi: "संत सेनाजी महाराज केशशिल्पी महामंडळ",
    nameEnglish: "Sant Senaji Maharaj Hairdresser Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "न्हावी" },
      { casteCode: 0, casteName: "हजाम" },
      { casteCode: 0, casteName: "महली" },
      { casteCode: 0, casteName: "म्हाली" },
      { casteCode: 0, casteName: "मारवाडी न्हावी" },
    ],
  },
  "snmavmu": {
    tenantId: "snmavmu",
    url: "snmavmu.msobcfdc.in",
    nameMarathi: "संत नरहरी महाराज आर्थिक विकास महामंडळ",
    nameEnglish: "Sant Narhari Maharaj Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "सोनार" },
      { casteCode: 0, casteName: "मारवाडी सोनार" },
      { casteCode: 0, casteName: "मारवाडी सुनार" },
      { casteCode: 0, casteName: "मारवाडी स्वर्णकार" },
    ],
  },
  "sssmavmu": {
    tenantId: "sssmavmu",
    url: "sssmavmu.msobcfdc.in",
    nameMarathi: "संत श्री संताजी महाराज आर्थिक विकास महामंडळ",
    nameEnglish: "Sant Shri Santaji Maharaj Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "तेली" },
      { casteCode: 0, casteName: "तिळवण तेली" },
      { casteCode: 0, casteName: "मराठा तेली" },
      { casteCode: 0, casteName: "तराणे तेली" },
      { casteCode: 0, casteName: "देशकर तेली" },
      { casteCode: 0, casteName: "एरंडेल तेली" },
      { casteCode: 0, casteName: "लिंगायत तेली" },
      { casteCode: 0, casteName: "एकबैल तेली" },
      { casteCode: 0, casteName: "दोन बैल तेली" },
      { casteCode: 0, casteName: "सावतेली" },
      { casteCode: 0, casteName: "एक बहिया तेली" },
      { casteCode: 0, casteName: "घाँची" },
    ],
  },
  "ssrmavmu": {
    tenantId: "ssrmavmu",
    url: "ssrmavmu.msobcfdc.in",
    nameMarathi: "संत श्री. रुपलाल महाराज आर्थिक विकास महामंडळ",
    nameEnglish: "Sant Shri Ruplal Maharaj Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "बारी" },
      { casteCode: 0, casteName: "बारई" },
    ],
  },
  "svrdlavmu": {
    tenantId: "svrdlavmu",
    url: "svrdlavmu.msobcfdc.in",
    nameMarathi: "स्व. विष्णूपंत रामचंद्र दादरे (लोणारी) आर्थिक विकास महामंडळ",
    nameEnglish: "Late Vishnupant Ramchandra Dadare (Lonari) Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "लोणारी" },
    ],
  },
  "skavmu": {
    tenantId: "skavmu",
    url: "skavmu.msobcfdc.in",
    nameMarathi: "सोळा कुलस्वामिनी आर्थिक विकास महामंडळ",
    nameEnglish: "Sola Kulswamini Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "लाडशाखीय वाणी" },
      { casteCode: 0, casteName: "वाणी" },
      { casteCode: 0, casteName: "काथार" },
      { casteCode: 0, casteName: "काथार वाणी" },
      { casteCode: 0, casteName: "कंठहार वाणी" },
      { casteCode: 0, casteName: "वैश्यवाणी" },
      { casteCode: 0, casteName: "वैश्य-वाणी" },
      { casteCode: 0, casteName: "वै. वाणी" },
      { casteCode: 0, casteName: "वैश्य वाणी" },
      { casteCode: 0, casteName: "पानारी" },
      { casteCode: 0, casteName: "कुलवंत वाणी" },
      { casteCode: 0, casteName: "कु.वाणी" },
      { casteCode: 0, casteName: "वाणी (कुलवंत)" },
      { casteCode: 0, casteName: "कुलवंत-वाणी" },
      { casteCode: 0, casteName: "कुणबी वाणी" },
      { casteCode: 0, casteName: "नेवी" },
      { casteCode: 0, casteName: "धाकड" },
      { casteCode: 0, casteName: "मिटकरीवाणी" },
      { casteCode: 0, casteName: "बोरळ" },
      { casteCode: 0, casteName: "बोराळ" },
      { casteCode: 0, casteName: "बोरूळ" },
      { casteCode: 0, casteName: "बोरड" },
      { casteCode: 0, casteName: "तांबोळी" },
    ],
  },
  "sssavmu": {
    tenantId: "sssavmu",
    url: "sssavmu.msobcfdc.in",
    nameMarathi: "श्री.संत नामदेव महाराज शिंपी समाज आर्थिक विकास महामंडळ",
    nameEnglish: "Shri Sant Namdev Maharaj Shimpi Samaj Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "शिंपी" },
      { casteCode: 0, casteName: "इद्रिसी / दर्जी" },
      { casteCode: 0, casteName: "साईसुतार" },
      { casteCode: 0, casteName: "जैन शिंपी" },
      { casteCode: 0, casteName: "श्रावक शिंपी" },
      { casteCode: 0, casteName: "शेतवाळ" },
      { casteCode: 0, casteName: "शेतवाल" },
      { casteCode: 0, casteName: "सैतवाल" },
      { casteCode: 0, casteName: "सैतवाळ" },
      { casteCode: 0, casteName: "मेरू शिंपी / मेरू क्षत्रिय शिंपी" },
      { casteCode: 0, casteName: "तेलगु दर्जी" },
      { casteCode: 0, casteName: "तेलगु शिंपी" },
      { casteCode: 0, casteName: "नामदेव शिंपी" },
      { casteCode: 0, casteName: "भावसार क्षत्रिय शिंपी" },
      { casteCode: 0, casteName: "भावगर" },
      { casteCode: 0, casteName: "शिव शिंपी" },
      { casteCode: 0, casteName: "नामदेव" },
    ],
  },
  "sbkssavmu": {
    tenantId: "sbkssavmu",
    url: "sbkssavmu.msobcfdc.in",
    nameMarathi: "संत भोजलिंग काका सुतार समाज आर्थिक विकास महामंडळ",
    nameEnglish: "Sant Bhojling Kaka Sutar Samaj Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "सुतार" },
      { casteCode: 0, casteName: "सुथार" },
      { casteCode: 0, casteName: "वाढई" },
      { casteCode: 0, casteName: "बाढी" },
      { casteCode: 0, casteName: "वढई" },
      { casteCode: 0, casteName: "बाढई" },
      { casteCode: 0, casteName: "बढई" },
      { casteCode: 0, casteName: "वाढी" },
      { casteCode: 0, casteName: "वाडी" },
      { casteCode: 0, casteName: "वधाई" },
      { casteCode: 0, casteName: "झाडे सुतार" },
      { casteCode: 0, casteName: "पांचाळ सुतार" },
      { casteCode: 0, casteName: "पांचाळ" },
      { casteCode: 0, casteName: "पंचाल" },
    ],
  },
  "lpsavmu": {
    tenantId: "lpsavmu",
    url: "lpsavmu.msobcfdc.in",
    nameMarathi: "लेवा पाटीदार समाज आर्थिक विकास महामंडळ",
    nameEnglish: "Leva Patidar Samaj Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "लेवा पटीदार" },
      { casteCode: 0, casteName: "लेवा कुणबी" },
      { casteCode: 0, casteName: "लेवा पाटील" },
    ],
  },
  "svpgsavmu": {
    tenantId: "svpgsavmu",
    url: "svpgsavmu.msobcfdc.in",
    nameMarathi: "सरदार वल्लभभाई पटेल गुजर समाज आर्थिक विकास महामंडळ",
    nameEnglish: "Sardar Vallabhbhai Patel Gujar Samaj Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "गुजर" },
      { casteCode: 0, casteName: "दोडे गुजर" },
      { casteCode: 0, casteName: "गुर्जर" },
      { casteCode: 0, casteName: "लेवा गुजर" },
      { casteCode: 0, casteName: "लेवे गुजर" },
      { casteCode: 0, casteName: "रेवे गुजर" },
      { casteCode: 0, casteName: "रेवा गुजर" },
      { casteCode: 0, casteName: "सुर्यवंशी गुजर" },
      { casteCode: 0, casteName: "बडगुजर तत्सम जाती लोंढारी" },
      { casteCode: 0, casteName: "बडगुजर तत्सम जाती पेंढारी" },
    ],
  },
  "asavmu": {
    tenantId: "asavmu",
    url: "asavmu.msobcfdc.in",
    nameMarathi: "आगरी समाज आर्थिक विकास महामंडळ",
    nameEnglish: "Agari Samaj Economic Development Corporation",
    subCompanyMarathi: "(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)",
    subCompanyEnglish: "(Subsidiary of MSOBCFDC Ltd)",
    cin: "U74999MH1999SGC119586",
    isParent: false,
    type: "Specialized",
    castes: [
      { casteCode: 0, casteName: "आगरी" },
      { casteCode: 0, casteName: "आगळे" },
      { casteCode: 0, casteName: "काळण" },
    ],
  },
};

// Default (parent company) config
const DEFAULT_TENANT = TENANT_MAP["msobcfdc"];

/**
 * Detect current tenant from hostname or ?tenant= query param (for localhost testing)
 */
function detectTenant() {
  // Check query param first (for localhost testing: ?tenant=svpgsavmu)
  try {
    var params = new URLSearchParams(window.location.search);
    var tenantParam = params.get("tenant");
    if (tenantParam && TENANT_MAP[tenantParam.toLowerCase()]) {
      return TENANT_MAP[tenantParam.toLowerCase()];
    }
  } catch (e) { /* URLSearchParams not supported in old browsers */ }

  var host = window.location.hostname.toLowerCase();
  var keys = Object.keys(TENANT_MAP);
  for (var i = 0; i < keys.length; i++) {
    var tid = keys[i];
    if (tid !== "msobcfdc" && host.indexOf(tid + ".") === 0) {
      return TENANT_MAP[tid];
    }
  }
  return DEFAULT_TENANT;
}

/**
 * Get tenant by tenantId
 */
function getTenantById(tenantId) {
  return TENANT_MAP[tenantId] || DEFAULT_TENANT;
}

/**
 * Filter caste dropdown list based on current tenant.
 * CasteName format from API: "183-लोणारी" (code-name).
 * For Universal tenants, returns all castes.
 * For Specialized tenants with casteCode > 0, matches the numeric prefix.
 * For Specialized tenants with casteCode = 0, matches by caste name text.
 */
function filterCasteDropdown(casteList, tenant) {
  if (!tenant || tenant.type !== "Specialized" || !tenant.castes || tenant.castes.length === 0) {
    return casteList;
  }
  if (!Array.isArray(casteList) || casteList.length === 0) {
    return casteList;
  }

  var validCasteCodes = tenant.castes.filter(function(c) { return c.casteCode > 0; }).map(function(c) { return c.casteCode; });
  var casteNames = tenant.castes.map(function(c) { return c.casteName.toLowerCase(); });

  return casteList.filter(function(item) {
    var casteName = (item.CasteName || "").trim();
    // Extract numeric prefix: "183-लोणारी" → 183
    var dashIndex = casteName.indexOf("-");
    var prefix = dashIndex > 0 ? parseInt(casteName.substring(0, dashIndex).trim(), 10) : NaN;
    var nameAfterDash = dashIndex > 0 ? casteName.substring(dashIndex + 1).trim().toLowerCase() : casteName.toLowerCase();

    // If tenant has valid numeric caste codes, match by prefix number
    if (validCasteCodes.length > 0 && !isNaN(prefix)) {
      return validCasteCodes.indexOf(prefix) !== -1;
    }

    // Otherwise match by caste name text
    if (casteNames.length > 0) {
      return casteNames.some(function(name) {
        return nameAfterDash.indexOf(name) !== -1 || name.indexOf(nameAfterDash) !== -1;
      });
    }

    return true;
  });
}

/**
 * Filter data array by caste based on current tenant.
 * For Universal tenants, returns all data unchanged.
 * For Specialized tenants, filters by numeric caste codes or text caste names.
 */
function filterByCaste(data, tenant) {
  if (!tenant || tenant.type !== "Specialized" || !tenant.castes || tenant.castes.length === 0) {
    return data;
  }
  if (!Array.isArray(data) || data.length === 0) {
    return data;
  }

  var casteCodes = tenant.castes.map(function(c) { return c.casteCode; });
  var casteNames = tenant.castes.map(function(c) { return c.casteName.toLowerCase(); });
  var validCasteCodes = casteCodes.filter(function(c) { return c > 0; });

  var sample = data[0];
  var numericFields = ["CasteID", "CasteCode", "SubCasteID", "casteId", "casteCode", "SubCasteCode"];
  var textFields = ["CasteName", "Caste", "CasteMarathi", "casteName", "caste", "SubCaste", "SubCasteName"];

  var numericField = null;
  var textField = null;
  for (var i = 0; i < numericFields.length; i++) {
    if (sample[numericFields[i]] !== undefined) { numericField = numericFields[i]; break; }
  }
  for (var j = 0; j < textFields.length; j++) {
    if (sample[textFields[j]] !== undefined) { textField = textFields[j]; break; }
  }

  if (validCasteCodes.length > 0 && numericField) {
    return data.filter(function(item) {
      return validCasteCodes.indexOf(Number(item[numericField])) !== -1;
    });
  } else if (textField && casteNames.length > 0) {
    return data.filter(function(item) {
      var val = (item[textField] || "").toLowerCase();
      return casteNames.some(function(name) {
        return val.indexOf(name) !== -1 || name.indexOf(val) !== -1;
      });
    });
  }

  return data;
}

export { TENANT_MAP, DEFAULT_TENANT, detectTenant, getTenantById, filterByCaste, filterCasteDropdown };
export default { TENANT_MAP, DEFAULT_TENANT, detectTenant, getTenantById };



// WEBPACK FOOTER //
// ./src/tenantConfig.js